import { ruleCounts } from '../../data/difficulty';

const getDifficulty = (state) => {
  return ruleCounts[state.settings.difficulty].displayName;
};

export { getDifficulty };
